module.exports = __webpack_public_path__ + "static/img/img-8.045f3244.png";